import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => {
  return createStyles({
    column: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginRight: theme.spacing(2),
      '&:last-child': {
        marginRight: 'initial'
      },
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
        marginTop: 0
      }
    },
    selectionFields: {
      display: 'grid',
      textAlign: 'left',
      gridTemplateColumns: '37% 37%',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr'
      },
      alignItems: 'center'
    },
    periodFilter: {
      marginTop: theme.spacing(-3)
    },
    downloadButtons: {
      display: 'grid',
      textAlign: 'left',
      gridTemplateColumns: '37% 37%',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr'
      },
      alignItems: 'center',
      marginTop: -theme.spacing(2)
    },
    archivedButtons: {
      display: 'grid',
      textAlign: 'left',
      gridTemplateColumns: '65% 35%',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr'
      },
      alignItems: 'center'
    },
    pdfWarning: {
      marginTop: theme.spacing(-1),
      marginBottom: theme.spacing(3)
    }
  });
});